export default {
  "700018": {
    //API获取config配置 coach
    code: "700018",
    needRepeat: 0, //0，不重试，1实时重试，2延迟重试
    needLoading: false,
    alert: true,
    isRequest: false
  },
  "100001": {
    //获取环境配置
    code: "100001",
    needRepeat: 0,
    needLoading: false,
    alert: true,
    isRequest: false
  },
  "700033": {
    //API学生登陆-coach
    code: "700033",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "700032": {
    //API手机号验证-coach
    code: "700032",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "700001": {
    //获取验证码 coach
    code: "700001",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "700034": {
    //重置密码
    code: "700034",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "700035": {
    //效验验证码-coach
    code: "700035",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "700002": {
    //验证码登录 coach
    code: "700002",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "700009": {
    //API获取快速问答列表 coach
    code: "700009",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700008": {
    //API获取标准快速问答 coach
    code: "700008",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "400025": {
    //API获取体验课标准快速问答
    code: "400025",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "400028": {
    //回放页获取标准快速问答
    code: "400028",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700030": {
    //HTTP补发接口 coach
    code: "700030",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700020": {
    //API获取资源文件get-zip coach
    code: "700020",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700015": {
    //API修改头像情况 coach
    code: "700015",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "700016": {
    //API获取默认头像列表 coach
    code: "700016",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "300163": {
    //API获取徽章
    code: "300163",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "700005": {
    //API进课消息 coach
    code: "700005",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700006": {
    //API退课 coach
    code: "700006",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "400035": {
    //API退课-录播课
    code: "400035",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300117": {
    //API轮训获取数据
    code: "300117",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700014": {
    //请求课件题json数据 coach
    code: "700014",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300209": {
    //客户评价数据补发
    code: "300209",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300136": {
    //获取直播课中徽章同学列表
    code: "300136",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700013": {
    //获取拉流地址接口 coach
    code: "700013",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300142": {
    //获取发题记录 coach
    code: "300142",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700019": {
    //获取发题记录-录播课 coach
    code: "700019",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700027": {
    //是否在可允许播放的范围内 coach
    code: "700027",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700007": {
    //门店虚拟体验课答题API coach
    code: "700007",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700017": {
    //API检查版本更新 coach
    code: "700017",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700031": {
    //ai伪弹幕列表 coach
    code: "700031",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700028": {
    //课前测答案上报 coach
    code: "700028",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300171": {
    //答题排行榜
    code: "300171",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300146": {
    //首页徽章上报
    code: "300146",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300173": {
    //学生端领取徽章排行榜1
    code: "300173",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300185": {
    //课时和课程状态查询
    code: "300185",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700036": {
    //设置弹幕颜色 coach
    code: "700036",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700011": {
    //首页base-data coach
    code: "700011",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "300154": {
    //获取长连接地址
    code: "300154",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700025": {
    //获取服务器时间 coach
    code: "700025",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300199": {
    //获取消息列表
    code: "300199",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "300159": {
    //获取单条消息详情
    code: "300159",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "300160": {
    //删除单条消息
    code: "300160",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  '700024': {
    //问题反馈 coach
    code: "700024",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  '700022': {
    //获取问题反馈标签 coach
    code: "700022",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "700021": {
    // 获取ossToken
    code: "700021",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700023": {
    // oss上传语音成功 coach
    code: "700023",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700029": {
    // 直接跳转直播页面 coach
    code: "700029",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "300174": {
    //语音连麦上报异常
    code: "300174",
    needRepeat: 0,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700004": {
    //请求课时列表 coach
    code: "700004",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "300230": {
    //获取体验课列表
    code: "300230",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "700012": {
    //获取礼物列表 coach
    code: "700012",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "900007": {
    //直播回放持续观看时间上报 coach
    code: "900007",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "900008": {
    //ai课持续观看时间上报 coach
    code: "900008",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300178": {
    //获取表扬信息
    code: "300178",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "800049": {
    //API获取学生报的班 coach
    code: "800049",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "300177": {
    //礼物补发接口
    code: "300177",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300189": { //pk补发接口
    code: "300189",
    needRepeat: 2,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "300201": {
    //回放页获取发题记录
    code: "300201",
    needRepeat: 1,
    needLoading: false,
    alert: false,
    isRequest: false
  },
  "700037": {
    //课后练习首页 coach
    code: "700037",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "700044": {
    //课后练习重新做题
    code: "700044",
    needRepeat: 0,
    needLoading: true,
    alert: false,
    isRequest: false
  },
  "700038": {
    //课后练习保存每道题答题信息
    code: "700038",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "700039": {
    //课后练习答题卡提交
    code: "700039",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "700040": {
    //课后练习订正
    code: "700040",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "700026": {
    //快速问答选择题样式 coach
    code: "700026",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "400026": {
    //头饰列表
    code: "400026",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  },
  "400027": {
    //修改头饰
    code: "400027",
    needRepeat: 0,
    needLoading: true,
    alert: true,
    isRequest: false
  }
};



// WEBPACK FOOTER //
// ./src/js/axiosConfig.js